export const SMART_T_STEP = {
  NONE: "none",
  UPLOAD_PASSPORT: "uploadPassport",
  PART_A_1: "partA1.1",
  PART_A_2: "partA1.2",
  PART_B: "partB",
  PART_C: "partC",
  PART_D: "partD",
  PART_E: "partE",
  UPLOAD_DOCUMENT: "uploadDocument",
  SURVEY: "survey",
  PART_F: "partF",
  PART_G: "partG",
  FROM_A: "fromA",
  SUMMARIZE: "summarize",
  VISA_INSUANCE: "visaInsuance",
  HEALTH_INSUANCE: "healthInsuance",
  ADD_JOB_POSITION: "addJobPosition",
  UPDATE_JOB_POSITION: "updateJobPositon",
  ADD_COMPAMY_INVESTMENT: "addCompanyInvestment",
  UPDATE_COMPANY_INFO: "updateCompanyInfo",
};

export const LTR_STEP = {
  NONE: "none",
  SHOW_FORM_STEP: "SHOW_FORM_STEP",
  SHOW_FORM_WORKPERMITSTEP: "SHOW_FORM_WORKPROMITSTEP",
  UPLOAD_PASSPORT: "uploadPassport",
  UPLOAD_DOCUMENT: "uploadDocument",
  SUMMARIZE: "summarize",
};

export const HOME_TAB = {
  INFORMATION: 0,
  SMART_VISA_SERVICE: 1,
  LTR_SERVICE: 2,
  WORK_PERMIT: 3,
  CHECK_STATUS: 4,
  PERSONAL_REFERENCE: 5,
  DIGITAL_WORKPERMIT_EDITOR: 6,
  // APPOINTMENT: 4,
  // MY_AGENCY: 5,
  // CONTACT_US: 3,
};

// export const HOME_TAB = {
//   LTR_SERVICE: 0,
//   CHECK_STATUS: 1,
//   PERSONAL_REFERENCE: 2,
//   // APPOINTMENT: 4,
//   MY_AGENCY: 3,
//   // CONTACT_US: 3,
// };
